var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpotMarkerLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#21323D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M4.498 9.69C3.213 9.355 2 8.136 2 6.506 2 3.433 4.345 2 6.996 2s4.996 2.295 4.996 5.126c0 0 .429 4.33-4.996 10.874l-2.905-3.66"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7,
  cy: 22,
  fill: "#21323D",
  rx: 5,
  ry: 2
})));
export default SvgSpotMarkerLight;